export default {
    PtWorkspaceFolderTree: {
        noData: '未找到對應文件夾',
        myWorkspace: '我的工作空間',
        sharedWorkspace: '來自分享的工作空間',
        publicWorkspace: '企業工作空間',
        noFolder: '該工作空間無文件夾，請嘗試選擇其他工作空間。',
    },
};
